import { environment } from "../../../environments/environment";
import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";
import { Utenteservice } from "../utente.service";
import { gridSimple, createGridConfig } from "./gridSettings/gridSettings";



export const gestioneAzienda: AnaColumn[] = [
  {
    itemType: "group", caption: '', class: '', colCount: "2", colGroup: 8, data: [

      {
        type: 'campo', colVisible: false, dataField: "annoInstallazione", dataType: "date", nCol: 3, caption: "Anno Installazione",
        width: "80", maxLength: "4", maxSize: 12, editorType: 'dxDateBox',
        //patterns:'^[0-9]+$', 
        format: 'yyyy',
        calendarOptions: {
          zoomLevel: 'decade',
          minZoomLevel: 'decade',
          maxZoomLevel: 'decade',
        },
        dateSerializationFormat: 'yyyy',
        validation: [
          { type: "pattern", value: '^[0-9]+$', message: "Il campo Anno Installazione deve contenere solo numeri" },
          { type: "required", message: "Campo Obbligatorio" },
          { type: "maxLength", value: "4", message: "Il campo Anno Installazione deve contenere massimo 4 cifre" },
          { type: "minLength", value: "4", message: "Il campo Anno Installazione deve contenere minimo 4 cifre" },
        ],
      },
      {
        type: 'campo', defaultValue: true,
        editorType: 'dxCheckBox', hideOnEdit: false, dataField: "isAttiva", caption: "Attiva", nCol: 5, class: 'd-flex flex-row justify-content-end', dataType: "boolean", disabled: true
      },
      {
        type: 'campo', maxLength: "40", dataField: "descrizione", dataType: "", nCol: 8, caption: "Descrizione", width: "375",
        validation: [{ type: "required", message: "Campo Obbligatorio" }],
      },

      { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
      {
        type: 'campoButton', dataField: "codiceFiscaleAzienda", nCol: 4, colVisible: true, caption: "C.F.", dataType: "",
        maxLength: '16', width: "200", maxSize: 16, class: "required", validation: [

          { type: "required", message: "Campo Obbligatorio" }
        ],
        button: {
          /*text: 'codiceFiscale',*/
          name: 'codiceFiscale',
          location: 'after',
          event: "OptionalIconButtonClick",
          hint: "ottieni le informazioni",
          icon: "glyphicon mdi mdi-file-search-outline"
        }
      },
      {
        type: 'campoButton', dataField: "pIvaAzienda", nCol: 4, colVisible: false, caption: "Partita IVA", dataType: "",
        maxLength: '11', width: "200", maxSize: 11,
        button: {
          /*text: 'infoPiva',*/
          name: 'infoPiva',
          location: 'after',
          event: "OptionalIconButtonClick",
          hint: "ottieni le informazioni",
          icon: "glyphicon mdi mdi-file-search-outline",
        }
      },
      {
        type: 'campoSpecial', dataField: "comune", nCol: 5, caption: "Comune", dataType: "",
        required: true,
        colVisible: true,
        disableOnUpdate: true,
        //class: "required",
        validation: [
          { type: "required", message: "Campo Obbligatorio" }
        ],
        maxSize: 45,
        width: "200",
        dynamic: {
          costantValue: [{ key: 'stato', value: 'IT' }],
          service: 'comune',
          dataSource: 'comune',
          autocomplete: false,
          checkValue: {
            checkValueMessage: 'Comune inesistente, vuoi continuare?',
            forceInsert: true
          },
          valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
          displayExpr: 'descrizione',
          caption: "Comuni",
          //queryString: '&$take=8000',
          componentType: 'dynamicGrid',
          related: ['cap', 'siglaProvincia|siglaProvincia', 'id|istatComune'],
          enableEditor: {
            add: false,
            remove: false,
            update: false
          },
          buttonOption: {
            text: 'Comuni',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Comuni',
            name: 'Comuni',
            location: 'after',
          },
          settingGrid: createGridConfig({
            ...gridSimple,


            colonne: [
              { type: 'campo', dataField: "id", dataType: "string", caption: "ISTAT", colWidth: '55' },
              { type: 'campo', dataField: "descrizione", dataType: "", caption: "Comune", colWidth: '300' },
              { type: 'campo', dataField: "siglaProvincia", dataType: "string", caption: "PR.", colWidth: '40' },
              { type: 'campo', dataField: "cap", dataType: "string", caption: "CAP", colWidth: '70' },


            ]
          }


          )

        }
      },
      {
        type: 'campo', colVisible: true, dataField: "frazione", caption: "Frazione", width: "200", nCol: 3,
      },
      {
        type: 'campoSpecial', colVisible: true, dataField: "siglaProvincia", nCol: 4, dataType: "", hideOnEdit: false, caption: "Provincia",
        maxSize: 2,
        maxLength: "2",
        width: "200",
        required: true,
        class: "required", validation: [

          { type: "required", message: "Campo Obbligatorio" }
        ],
        editorType: 'dxSelectBox',
        lista: {
          dataSource: 'provincia',
          valueExpr: 'siglaProvincia',
          displayExpr: 'descrizione',
          static: false,


        }
      },
      { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
      {
        type: 'campo', colVisible: false, dataField: "indirizzo", nCol: 6, caption: "Indirizzo", class: "required", validation: [

          { type: "required", message: "Campo Obbligatorio" }
        ],
      },
      {
        type: 'campo', dataField: "civico", caption: "Civico", dataType: "", nCol: 2, width: 7 * aspect, maxSize: 7, maxLength: "7"
      },
      {
        type: 'campo', colVisible: false, dataField: "cap", nCol: 3, caption: "CAP", class: "required", validation: [

          { type: "required", message: "Campo Obbligatorio" }
        ],
      },
      {
        type: 'campo', colVisible: false, dataField: "istatComune", nCol: 2, caption: "ISTAT", maxLength: "6", class: "required", validation: [

          { type: "required", message: "Campo Obbligatorio" }
        ],
      },
      /*
      {
        type: 'campo', colVisible: false, colSpan:'2', dataField: "pec", caption: "PEC",  width: 200
      },
      */
    ]
  }








];


export const gestioneAziendaAdmin: AnaColumn[] = [

  {
    configuration:
    {
      titleGriglia: 'Gestione informazioni azienda',
      titleForm: 'informazioni azienda',
      breadcrumbCaption: 'informazioni azienda',
      service: 'gestioneAziendaAdmin',
      api: '',
      filterList: '/',
      filterEditor: '/$',
      helpDoc: 'GESTIONEAZIENDE.html',
      formType: 'simple',
      queryFilter: [],
      idTabRif: [],
      masterKey: 'id',
      nCol: 1,
      template: 'form'


    }

  },

  {
    itemType: "group", caption: '', class: '', colCount: "2", colGroup: 5, data: [

      {
        type: 'campo', colVisible: false, dataField: "annoInstallazione", dataType: "date", nCol: 3, caption: "Anno Installazione",
        width: "80", maxLength: "4", maxSize: 12, editorType: 'dxDateBox',
        //patterns:'^[0-9]+$', 
        format: 'yyyy',
        calendarOptions: {
          zoomLevel: 'decade',
          minZoomLevel: 'decade',
          maxZoomLevel: 'decade',
        },
        dateSerializationFormat: 'yyyy',
        validation: [
          { type: "pattern", value: '^[0-9]+$', message: "Il campo Anno Installazione deve contenere solo numeri" },
          { type: "required", message: "Campo Obbligatorio" },
          { type: "maxLength", value: "4", message: "Il campo Anno Installazione deve contenere massimo 4 cifre" },
          { type: "minLength", value: "4", message: "Il campo Anno Installazione deve contenere minimo 4 cifre" },
        ],
      },
      {
        type: 'campo', defaultValue: true,
        editorType: 'dxCheckBox', hideOnEdit: false, dataField: "isAttiva", caption: "Attiva", nCol: 5, class: 'd-flex flex-row justify-content-end', dataType: "boolean", disabled: true
      },
      {
        type: 'campo', maxLength: "40", dataField: "descrizione", dataType: "", nCol: 8, caption: "Descrizione", width: "375",
        validation: [{ type: "required", message: "Campo Obbligatorio" }],
      },

      { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
      {
        type: 'campoButton', dataField: "codiceFiscaleAzienda", nCol: 4, colVisible: true, caption: "C.F.", dataType: "",
        maxLength: '16', width: "200", maxSize: 16, class: "required", validation: [

          { type: "required", message: "Campo Obbligatorio" }
        ],
        button: {
          /*text: 'codiceFiscale',*/
          name: 'codiceFiscale',
          location: 'after',
          event: "OptionalIconButtonClick",
          hint: "ottieni le informazioni",
          icon: "glyphicon mdi mdi-file-search-outline"
        }
      },
      {
        type: 'campoButton', dataField: "pIvaAzienda", nCol: 4, colVisible: false, caption: "Partita IVA", dataType: "",
        maxLength: '11', width: "200", maxSize: 11,
        button: {
          /*text: 'infoPiva',*/
          name: 'infoPiva',
          location: 'after',
          event: "OptionalIconButtonClick",
          hint: "ottieni le informazioni",
          icon: "glyphicon mdi mdi-file-search-outline",
        }
      },
      {
        type: 'campoSpecial', dataField: "comune", nCol: 5, caption: "Comune", dataType: "",
        required: true,
        colVisible: true,
        disableOnUpdate: true,

        validation: [
          { type: "required", message: "Campo Obbligatorio" }
        ],
        maxSize: 45,
        width: "200",
        dynamic: {
          costantValue: [{ key: 'stato', value: 'IT' }],
          service: 'comune',
          dataSource: 'comune',
          autocomplete: false,
          checkValue: {
            checkValueMessage: 'Comune inesistente, vuoi continuare?',
            forceInsert: true
          },
          valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
          displayExpr: 'descrizione',
          caption: "Comuni",
          //queryString: '&$take=8000',
          componentType: 'dynamicGrid',
          related: ['cap', 'siglaProvincia|siglaProvincia', 'id|istatComune'],
          enableEditor: {
            add: false,
            remove: false,
            update: false
          },
          buttonOption: {
            text: 'Comuni',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Comuni',
            name: 'Comuni',
            location: 'after',
          },
          settingGrid: createGridConfig({
            ...gridSimple,


            colonne: [
              { type: 'campo', dataField: "id", dataType: "string", caption: "ISTAT", colWidth: '55' },
              { type: 'campo', dataField: "descrizione", dataType: "", caption: "Comune", colWidth: '300' },
              { type: 'campo', dataField: "siglaProvincia", dataType: "string", caption: "PR.", colWidth: '40' },
              { type: 'campo', dataField: "cap", dataType: "string", caption: "CAP", colWidth: '70' },


            ]
          }


          )

        }
      },
      {
        type: 'campo', colVisible: true, dataField: "frazione", caption: "Frazione", width: "200", nCol: 3,
      },
      {
        type: 'campoSpecial', colVisible: true, dataField: "siglaProvincia", nCol: 4, dataType: "", hideOnEdit: false, caption: "Provincia",
        maxSize: 2,
        maxLength: "2",
        width: "200",
        required: true,
        class: "required", validation: [

          { type: "required", message: "Campo Obbligatorio" }
        ],
        editorType: 'dxSelectBox',
        lista: {
          dataSource: 'provincia',
          valueExpr: 'siglaProvincia',
          displayExpr: 'descrizione',
          static: false,


        }
      },
      { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },
      {
        type: 'campo', colVisible: false, dataField: "indirizzo", nCol: 6, caption: "Indirizzo", class: "required", validation: [

          { type: "required", message: "Campo Obbligatorio" }
        ],
      },
      {
        type: 'campo', dataField: "civico", caption: "Civico", dataType: "", nCol: 2, width: 7 * aspect, maxSize: 7, maxLength: "7"
      },
      {
        type: 'campo', colVisible: false, dataField: "cap", nCol: 3, caption: "CAP", class: "required", validation: [

          { type: "required", message: "Campo Obbligatorio" }
        ],
      },
      {
        type: 'campo', colVisible: false, dataField: "istatComune", nCol: 2, caption: "ISTAT", maxLength: "6", class: "required", validation: [

          { type: "required", message: "Campo Obbligatorio" }
        ],
      },
      /*
      {
        type: 'campo', colVisible: false, colSpan:'2', dataField: "pec", caption: "PEC",  width: 200
      },
      */
    ]
  }








];